import { useSuspenseQuery } from "@tanstack/react-query";
import { useState } from "react";
import { patchesQueryOptions } from "../api/patch.queries";
import type { PatchResponse } from "../settings.patch.utils";
import { PatchEditor } from "./PatchEditor";
import { PatchList } from "./PatchList";

type EditorSelection = { kind: "new" } | { kind: "existing"; id: string };

export function GeneralSettings() {
  const { data: patches } = useSuspenseQuery(patchesQueryOptions);
  const [selection, setSelection] = useState<EditorSelection | null>(null);

  if (selection) {
    const patch =
      selection.kind === "existing"
        ? patches.find((item) => item.id === selection.id)
        : undefined;

    if (selection.kind === "new" || patch) {
      return (
        <PatchEditor
          key={patch?.id ?? "new"}
          patch={patch}
          onClose={() => setSelection(null)}
          onSaved={(saved: PatchResponse) =>
            setSelection({ kind: "existing", id: saved.id })
          }
          onDeleted={() => setSelection(null)}
        />
      );
    }
  }

  return (
    <PatchList
      patches={patches}
      onCreate={() => setSelection({ kind: "new" })}
      onSelect={(id) => setSelection({ kind: "existing", id })}
    />
  );
}
